/* eslint max-len: ["error", { "code": 700 }] */

const html = require("choo/html");
const ButtonIcon = require("./buttonicon.js");
module.exports = function Carousel(args) {
  const {
    selectedItem = 0,
    disabled,
    items = [],
    onChange = () => false,
    lastItemHelp = false,
  } = args;
  function NavItem(item, i) {
    let active = true;
    if (disabled || i !== selectedItem) {
      active = false;
    }
    if (lastItemHelp && i === items.length - 1) {
      return html`
      <div style="position:absolute; right: 0;" class="help-icon">
        ${ButtonIcon({
          icon: "question",
          size: "small",
          type: "circle",
          id: "glitch-panel-help-button",
          onClick: () => onChange(i),
          selected: selectedItem === i,
        })}
        </div>
      `;
    }
    return html`
      <div
        id="panel-nav-item-${i}" class="navigation-item ${active ? "active" : ""}"
        onclick=${() => onChange(i)}
      ></div>
    `;
  }

  return html`
    <div class="carousel">
      ${items.slice(selectedItem, selectedItem + 1)}
      <div class="navigation">
        ${items.map((item, i) => NavItem(item, i, selectedItem))}
      </div>
    </div>
  `;
};
